import React, {useState} from "react";
import {Button} from "semantic-ui-react";
import {startBhHouseJob, updateWorkFlow} from "../../commonApis";


function UnHoldShipmentButton(props){
    const shipId = props.shipId;
    const startJob =  async (type) => {
        let brokerUserGuid = props.kxUser.userBasicInfo.userGuid;
        let eventType = "ENTRY_IN_PROCESS";
        props.toggleLoaderFunc("Holding the shipment..."); 
        startBhHouseJob(props.shipId,"BH_BROKER_ASSIGNED", brokerUserGuid).then( async (res)=>{
            startBhHouseJob(props.shipId, "BH_BROKER_IN_PROCESS", brokerUserGuid).then( async (res)=>{
                updateWorkFlow(shipId, eventType, brokerUserGuid).then(()=>{
                    props.searchByID(shipId)
                })
            })
        })
        return;
    }
    return(
        <Button
            id='holdshipment-start-job'
            size="mini"
            key='UNHOLD_SHIPMENT'
            className="sv todo-button primaryBtn"
            title='Un Hold this shipment'
            onClick={(e) => {
                e.stopPropagation();
                startJob()
            }}
            >
            START JOB
        </Button>
    ) 
}
export default UnHoldShipmentButton;